import React from 'react';
import OnboardingPageOverlay from '../../shared/OnboardingPageOverlay';
import SuppliersOnboardingStep from './SuppliersOnboardingStep';

const SuppliersOnboardingOverlay: React.FC = () => (
  <OnboardingPageOverlay stepId="suppliers">
    {(onDismiss) => <SuppliersOnboardingStep onDismiss={onDismiss} />}
  </OnboardingPageOverlay>
);

export default SuppliersOnboardingOverlay;
